import type { KnowledgeEdgeView } from './surfaces'

/** The note at an edge's other end from `id`, or null when the edge does not touch it. */
export function otherEnd(edge: KnowledgeEdgeView, id: string): string | null {
    if (edge.source === id) return edge.target
    if (edge.target === id) return edge.source
    return null
}
